import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "trigger"]
  static values = {
    maxHeight: { type: Number, default: 96 },
    modalTitle: { type: String, default: "Details" }
  }

  connect() {
    this.observer = new ResizeObserver(() => this.#checkOverflow())
    this.observer.observe(this.contentTarget)
  }

  disconnect() {
    this.observer?.disconnect()
  }

  open(event) {
    event.preventDefault()

    const modal = this.#buildModal()
    document.body.appendChild(modal)
    $(modal).on("hidden.bs.modal", () => modal.remove())
    $(modal).modal("show")
  }

  #checkOverflow() {
    if (this.contentTarget.scrollHeight > this.maxHeightValue) {
      this.contentTarget.style.maxHeight = `${this.maxHeightValue}px`
      this.contentTarget.style.overflow = "hidden"
      this.triggerTarget.classList.remove("hidden")
    } else {
      this.contentTarget.style.maxHeight = ""
      this.contentTarget.style.overflow = ""
      this.triggerTarget.classList.add("hidden")
    }
  }

  #buildModal() {
    const modal = document.createElement("div")
    modal.className = "modal fade"
    modal.tabIndex = -1
    modal.innerHTML = `
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <a class="close" data-dismiss="modal">&times;</a>
            <h4 class="modal-title"></h4>
          </div>
          <div class="modal-body force-wrap-word pre-wrap"></div>
        </div>
      </div>
    `
    modal.querySelector(".modal-title").textContent = this.modalTitleValue
    const body = modal.querySelector(".modal-body")
    Array.from(this.contentTarget.childNodes).forEach(node => body.appendChild(node.cloneNode(true)))
    return modal
  }
}
